import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { Delete, Image, PictureAsPdf, Check } from '@mui/icons-material';
import { DropWrapper, DropZone } from 'components/dropZone/components';


type DropImageProps = {
    upload: (file: File) => void;
    remove?: () => void;
    image?: { type: string, file: string };
    title: string;
}

const DropPdfOrImage = ({ upload, remove, image, title }: DropImageProps) => {
    const { t } = useTranslation();
    const [preview, setPreview] = useState(image);

    const onDropAccepted = (acceptedFiles: File[]) => {
        let file = acceptedFiles[0]

        setPreview({
            type: file.type,
            file: URL.createObjectURL(file),
        });
        upload(file);
    };

    const onDelete = () => {
        setPreview(undefined);
        remove?.();
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDropAccepted,
        accept: {
            'image/*': ['.jpeg', '.png'],
            'application/pdf': ['.pdf'],
        },
        multiple: false,
    });

    const thumb = preview ? (
        preview.type === 'application/pdf' ?
            (isMobile ? (
                <Box sx={{position: 'relative', display: 'inline-block'}}>
                    <PictureAsPdf
                        color="disabled"
                    />
                    <Check
                        sx={{
                            position: 'absolute',
                            bottom: '1rem',
                            right: '-1rem',
                            width: '4rem !important',
                            height: '4rem !important',
                        }}
                        color="success"
                    />
                </Box>
            ) : (
                <embed
                    src={preview.file + '#navpanes=0&scrollbar=0&pagemode=none"'}
                    type="application/pdf"
                    height={window.innerHeight - 260}
                    width="100%"
                />
            )) :
            <img src={preview.file} alt="uploaded preview" style={{height:'auto'}}/>
    ) : <Image/>;

    return (
        <DropWrapper>
            {preview && remove && <div className="delete btn-icon text-danger" onClick={onDelete}><Delete /></div>}

            <DropZone {...getRootProps({ className: 'drop-image' })}>
                <input {...getInputProps()} />
                <div className="title">{thumb}<br/>{title}</div>
                {isDragActive &&
                    <div className="drop-here">{t('drop_files_here')}...</div>
                }
            </DropZone>
        </DropWrapper>
    )
}

export default DropPdfOrImage;
